var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "viewport",
              rawName: "v-viewport",
              value: _vm.onViewportIntersection,
              expression: "onViewportIntersection",
            },
          ],
          staticClass: "rb-algolia-trending-items",
        },
        [
          _vm.title
            ? _c("rb-text-module", {
                attrs: { "text-align": "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1549153072
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("rb-algolia-base-editorial-products", {
            attrs: {
              "data-element-id": _vm.dataElementId,
              "internal-content": _vm.internalContent,
              products: _vm.products,
              "wishlist-icon-is-visible": _vm.wishlistIconIsVisible,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }